export default "__VITE_ASSET__iYw76Ic8__"